import { activationStates } from "variables/activations";

const ActivationStatusChip = ({ value }) => {
    return (
        <div
            className={`w-fit rounded-[8px] border px-2 py-0.5 text-center text-xs font-semibold text-white transition duration-200 ${
                value === activationStates.COMPLETED
                    ? "border-green-500 text-green-500"
                    : value === "PENDING_COMPLETION"
                    ? "border-blue-500 text-blue-500"
                    : value === "CANCELLED"
                    ? "border-red-500 text-red-500"
                    : value === "PENDING_CONFIRMATION"
                    ? "border-amber-500 text-amber-500"
                    : value === "WAITING_FOR_SERVER_CODE"
                    ? "border-blue-500 text-blue-500"
                    : null
            }`}
        >
            {value === activationStates.COMPLETED
                ? "COMPLETATO"
                : value === activationStates.PENDING_COMPLETION
                ? "DA COMPLETARE"
                : value === activationStates.CANCELLED
                ? "ANNULLATA"
                : value === activationStates.PENDING_CONFIRMATION
                ? "IN APPROVAZIONE"
                : value === activationStates.WAITING_FOR_SERVER_CODE
                ? "DA COMPLETARE, MANCA IL CODICE SERVER"
                : "COMPLETATO"}
        </div>
    );
};

export default ActivationStatusChip;
